import page from '../shared/qualify/page';
import Dashboard from './dashboard';

export default ({ path, actionPipe }) =>
  page({
    path,
    actionPipe,
    scenario: 'Affordability',
    Dashboard
  });



// WEBPACK FOOTER //
// ./src/products/affordability/index.js